import { IPriceListData } from "common/records/PriceList";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IPriceListOverviewData } from "common/records/PriceListOverview";

export const FETCH_PRICE_LIST = "@pricelist/FETCH_PRICE_LIST";
export const RECEIVE_PRICE_LIST = "@pricelist/RECEIVE_PRICE_LIST";
export const SET_PRICE_LIST_LOADED = "@pricelist/SET_PRICE_LIST_LOADED";
export const RECEIVE_PRICE_LISTS = "@pricelist/RECEIVE_PRICE_LISTS";
export const RECEIVE_PRICE_LIST_OVERVIEW = "@pricelist/RECEIVE_PRICE_LIST_OVERVIEW";
export const RECEIVE_PRICE_LIST_OVERVIEWS = "@pricelist/RECEIVE_PRICE_LIST_OVERVIEWS";

export const PriceListActions = {
  fetchPriceList: (priceListId: number) => createAction(FETCH_PRICE_LIST, { priceListId }),
  receivePriceList: (priceList: IPriceListData, kind: string, pushToList?: boolean) =>
    createAction(RECEIVE_PRICE_LIST, { priceList, kind, pushToList }),
  receivePriceLists: (priceLists: IPriceListData[], kind: string) =>
    createAction(RECEIVE_PRICE_LISTS, { priceLists, kind }),
  setPriceListLoaded: (priceListId: number) => createAction(SET_PRICE_LIST_LOADED, { priceListId }),
  receivePriceListOverview: (priceListOverview: Partial<IPriceListOverviewData>, pushToList?: boolean) =>
    createAction(RECEIVE_PRICE_LIST_OVERVIEW, { priceListOverview, pushToList }),
  receivePriceListOverviews: (priceListOverviews: Partial<IPriceListOverviewData>[]) =>
    createAction(RECEIVE_PRICE_LIST_OVERVIEWS, { priceListOverviews }),
};
export type PriceListActions = ActionsUnion<typeof PriceListActions>;
